export default {"src":"/_next/static/media/No-Flights.cf6b2a43.svg","height":622,"width":895,"blurWidth":0,"blurHeight":0};